import ReferralStepDot from "../ReferralStepDot"
import styles from './ReferralSteps.module.css'

export interface IReferralStepsProps {
    plusEnabled: boolean
    isMobile: boolean
}

export function ReferralSteps(props: IReferralStepsProps) {
    const money = props.plusEnabled ? "баллы Плюса" : "бонусы Драйва"
    if (props.isMobile) {
        const highlightedTextClassName = styles.highlighted_box_mobile
        return <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", paddingTop: "50px", paddingBottom: "100px" }}>
            <div className={styles.line_mobile}>
                <ReferralStepDot smallSize="5px" bigSize="19px" />
                <div style={{ width: "2px", height: "80px", backgroundColor: "black" }} />
                <ReferralStepDot smallSize="5px" bigSize="19px" />
                <div style={{ width: "2px", height: "80px", backgroundColor: "black" }} />
                <ReferralStepDot smallSize="5px" bigSize="19px" />
            </div>
            <div className={styles.text_labels_container_mobile}>
                <div style={{ width: "274px", top: "-8px", position: "relative" }}>
                    Даёте <br /><HighlightedText text="промокод" className={highlightedTextClassName} marginLeft={-14} /> друзьям
                </div>
                <div style={{ top: "92px", position: "absolute" }}>
                    Друзья ездят<br /><HighlightedText text="со скидкой" className={highlightedTextClassName} marginLeft={-14} />
                </div>
                <div style={{ top: "196px", position: "absolute" }}>
                    Вам — <HighlightedText text={money} className={highlightedTextClassName} marginLeft={0} /><br />с их поездок
                </div>
            </div>
        </div>
    } else {
        const highlightedTextClassName = styles.highlighted_box;
        return <div style={{ display: "flex", flexDirection: "column" }}>
            <div className={styles.line}>
                <ReferralStepDot smallSize="9px" bigSize="25px" />
                <div style={{ width: "347px", height: "2px", backgroundColor: "black" }} />
                <ReferralStepDot smallSize="9px" bigSize="25px" />
                <div style={{ width: "347px", height: "2px", backgroundColor: "black" }} />
                <ReferralStepDot smallSize="9px" bigSize="25px" />
            </div>
            <div className={styles.text_labels_container}>
                <div style={{ position: "relative" }}>
                    <span>
                        Даёте <br /> <HighlightedText className={highlightedTextClassName} text="промокод" marginLeft={-14} /> друзьям
                    </span>
                </div>
                <div style={{ left: "372px", top: "0px", position: "absolute" }}>
                    <span>
                        Друзья ездят <br /> <HighlightedText className={highlightedTextClassName} text="со скидкой" marginLeft={-14} />
                    </span>
                </div>
                <div style={{ left: "744px", top: "0px", width: "500px", position: "absolute" }}>
                    <span>
                        Вам —  <HighlightedText className={highlightedTextClassName} text={money} marginLeft={0} /><br />с их поездок
                    </span>
                </div>
            </div>
        </div>
    }

}

function HighlightedText({ text, className, marginLeft }: { text: string, className: string, marginLeft: number }) {
    return <div className={className} style={{ marginLeft: `${marginLeft}px` }}>
        {text}
    </div>
}